import { Dialog, DialogContent, Typography } from '@mui/material';
import { ISubmodelElement, SubmodelElementCollection } from 'api/v3/aas_core_meta/types';
import { messages } from 'i18n/localization';
import { FormattedMessage } from 'react-intl';
import { SubmodelElementRenderer } from '../SubmodelElementRenderer';

type DocumentDetailsModalProps = {
    readonly document: SubmodelElementCollection;
    readonly handleClose: () => void;
    readonly open: boolean;
};

export function DocumentDetailsDialog(props: DocumentDetailsModalProps) {
    const document = props.document;

    if (!document.value) {
        return <></>;
    }

    return (
        <Dialog open={props.open} onClose={props.handleClose} fullWidth maxWidth="md">
            <DialogContent>
                <Typography variant="h3" sx={{ mb: 3 }}>
                    <FormattedMessage {...messages.mnestix.documentDetails} />
                </Typography>
                {document.value.map((el, i) => (
                    <SubmodelElementRenderer submodelElement={el as ISubmodelElement} key={i} hasDivider={i !== 0} />
                ))}
            </DialogContent>
        </Dialog>
    );
}
